// extracted by mini-css-extract-plugin
export default {"icon":"ControlledTriggerIcon_icon__xQtJR"};